import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { loginAPI, getSecretKey } from '../services/authServices';

// async thunk lấy secretKey
export const fetchSecretKey = createAsyncThunk(
    'auth/fetchSecretKey',
    async (_, thunkAPI) => {
        const state = thunkAPI.getState();
        const token = state.auth.token;

        try {
            const res = await getSecretKey(token);
            const { secretKey, stime } = res.data;
            return { secretKey, stime };
        } catch (error) {
            return thunkAPI.rejectWithValue(error.response?.data || 'Fetch secretKey failed');
        }
    }
);

// async thunk login
export const loginAsync = createAsyncThunk(
    'auth/loginAsync',
    async ({ username, password }, thunkAPI) => {
        try {
            const res = await loginAPI({ username, password });
            if (res.success) {
                return {
                    token: res.data.accessToken,
                    username
                };
            } else {
                return thunkAPI.rejectWithValue(res.message);
            }
        } catch (error) {
            return thunkAPI.rejectWithValue(error.message || 'Login failed');
        }
    }
);

const authSlice = createSlice({
    name: 'auth',
    initialState: {
        isAuthenticated: false,
        user: null,
        token: null,
        error: null,
        secretKey: '',
        stime: '',
        loadingSecretKey: false,
        loadingLogin: false,
    },
    reducers: {
        logout: (state) => {
            state.isAuthenticated = false;
            state.user = null;
            state.token = null;
            state.error = null;
            state.secretKey = '';
            state.stime = '';
            state.loadingLogin = false;
        },
        restoreAuthState: (state) => {
            state.token = localStorage.getItem('token');
            state.secretKey = localStorage.getItem('secretKey');
            state.stime = localStorage.getItem('stime');
            state.isAuthenticated = !!state.token;
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchSecretKey.pending, (state) => {
                state.loadingSecretKey = true;
            })
            // Trong fetchSecretKey.fulfilled
            .addCase(fetchSecretKey.fulfilled, (state, action) => {
                state.secretKey = action.payload.secretKey;
                state.stime = action.payload.stime;
                localStorage.setItem('secretKey', action.payload.secretKey);
                localStorage.setItem('stime', action.payload.stime);
                state.loadingSecretKey = false;
            })
            .addCase(fetchSecretKey.rejected, (state) => {
                state.loadingSecretKey = false;
            })

            .addCase(loginAsync.pending, (state) => {
                state.loadingLogin = true;
                state.error = null;
            })
            // Trong loginAsync.fulfilled
            .addCase(loginAsync.fulfilled, (state, action) => {
                state.isAuthenticated = true;
                state.user = { username: action.payload.username };
                state.token = action.payload.token;
                localStorage.setItem('token', action.payload.token);
                state.loadingLogin = false;
            })
            .addCase(loginAsync.rejected, (state, action) => {
                state.isAuthenticated = false;
                state.user = null;
                state.token = null;
                state.error = action.payload || 'Login failed';
                state.loadingLogin = false;
            });
    },
});

// Export action logout, async thunks và reducer đúng chuẩn
export const { logout, restoreAuthState } = authSlice.actions;
export default authSlice.reducer;
